var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#226ED4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 21,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 21,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 27,
    r: 3,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 33,
    r: 3,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 33,
    r: 3,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 27,
    r: 3,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 15,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 21,
    r: 2,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 33,
    r: 2,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 39,
    r: 2,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 33,
    r: 2,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 21,
    r: 2,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 14,
    r: 1.5,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 14,
    r: 1.5,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 27,
    r: 1.5,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 40,
    r: 1.5,
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 40,
    r: 1.5,
    fill: "white"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 27,
    r: 1.5,
    fill: "white"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 8,
    r: 1,
    fill: "white"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 27,
    r: 1,
    fill: "white"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 46,
    r: 1,
    fill: "white"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 27,
    r: 1,
    fill: "white"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.067,
    cy: 10.2955,
    r: 1,
    transform: "rotate(30 37.067 10.2955)",
    fill: "white"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.1865,
    cy: 36.5,
    r: 1,
    transform: "rotate(30 44.1865 36.5)",
    fill: "white"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.067,
    cy: 44.2045,
    r: 1,
    transform: "rotate(30 16.067 44.2045)",
    fill: "white"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.94745,
    cy: 18,
    r: 1,
    transform: "rotate(30 8.94745 18)",
    fill: "white"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.2045,
    cy: 18.067,
    r: 1,
    transform: "rotate(60 44.2045 18.067)",
    fill: "white"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5001,
    cy: 44.1866,
    r: 1,
    transform: "rotate(60 37.5001 44.1866)",
    fill: "white"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.2956,
    cy: 37.067,
    r: 1,
    transform: "rotate(60 9.2956 37.067)",
    fill: "white"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0001,
    cy: 9.94745,
    r: 1,
    transform: "rotate(60 17.0001 9.94745)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAda);
export default __webpack_public_path__ + "static/media/ada.8feae8091ec45c926670a966120fa976.svg";
export { ForwardRef as ReactComponent };